export default "__VITE_ASSET__d3974d44__"